<!-- ── En-tête de page ───────────────────────────────────────────── -->
 
<section class="cuspage-hero">
        <div class="cuspage-hero__bg" ></div>
        <div class="container">
            <div class="cuspage-hero__content">
                <span class="cuspage-hero__tagline" style="display:none;">
                    <i class="icofont-justice-hammer"></i>
                    {{ 'galerie_titre' | translate }}
                </span>
                <h1 class="cuspage-hero__title">{{ pageTitleKey | translate }}</h1>
                <p class="cuspage-hero__sub">{{ 'pub_publications' | translate }} </p>  
            </div>
        </div>
    </section>
<!-- ── Contenu principal ─────────────────────────────────────────── -->
<section class="docs-page section-padding">
    <div class="container">

        <!-- ── Onglets catégorie ── -->
        <div class="docs-tabs">
            <button
                *ngFor="let cat of categories"
                class="docs-tab-btn"
                [class.active]="activeCategory === cat.key"
                (click)="selectCategory(cat.key)">
                {{ cat.titleKey | translate }}
            </button>
        </div>

        <!-- ── Barre de recherche ── -->
        <div class="docs-search-bar">
            <div class="docs-search-input-wrap">
                <i class="icofont-search-1 docs-search-icon"></i>
                <input
                    type="text"
                    class="docs-search-input"
                    [placeholder]="'doc_recherche_ph' | translate"
                    [value]="searchQuery"
                    (input)="onSearch($any($event.target).value)" />
                <button *ngIf="searchQuery" class="docs-search-clear" (click)="clearSearch()">
                    <i class="icofont-close-circled"></i>
                </button>
            </div>
        </div>

        <!-- ── Compteur résultats ── -->
        <div class="docs-meta" *ngIf="!loading">
            <span>{{ total }} {{ 'doc_resultats' | translate }}</span>
        </div>

        <!-- ── Grille de fichiers ── -->
        <ng-container *ngIf="!loading; else loadingTpl">

            <div class="docs-grid" *ngIf="files.length > 0; else emptyTpl">
                <div class="doc-card wow fadeInUp" *ngFor="let file of files" data-wow-duration="800ms">

                    <!-- Icône type de fichier -->
                    <div class="doc-card__icon-wrap" [style.background]="fileColor(file.type) + '1a'">
                        <i [class]="fileIcon(file.type)" [style.color]="fileColor(file.type)"></i>
                    </div>

                    <!-- Infos -->
                    <div class="doc-card__body">
                        <span class="doc-card__type-badge" [style.background]="fileColor(file.type)">
                            {{ (file.type || '?') | uppercase }}
                        </span>
                        <h4 class="doc-card__title">{{ tf(file.title) || file.translated_title }}</h4>
                        <p class="doc-card__desc" *ngIf="tf(file.description) || file.translated_description">
                            {{ tf(file.description) || file.translated_description | slice:0:120 }}
                        </p>
                        <div class="doc-card__meta">
                            <span><i class="icofont-calendar"></i> {{ formatDate(file.upload_date) }}</span>
                            <span><i class="icofont-paper-clip"></i> {{ formatSize(file.size) }}</span>
                        </div>
                    </div>

                    <!-- Bouton télécharger -->
                    <a [href]="downloadUrl(file)"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="doc-card__download careox-btn careox-btn--sm">
                        <i class="icofont-download-alt"></i>
                        {{ 'doc_telecharger' | translate }}
                    </a>

                </div>
            </div>

            <!-- Aucun résultat -->
            <ng-template #emptyTpl>
                <div class="docs-empty">
                    <i class="icofont-file-text"></i>
                    <p>{{ 'doc_aucun_resultat' | translate }}</p>
                </div>
            </ng-template>

        </ng-container>

        <!-- Chargement -->
        <ng-template #loadingTpl>
            <app-loading></app-loading>
        </ng-template>

        <!-- Erreur -->
        <div class="docs-error" *ngIf="error">
            <i class="icofont-warning"></i>
            <p>{{ error | translate }}</p>
        </div>

        <!-- ── Pagination ── -->
        <div class="docs-pagination" *ngIf="!loading && totalPages > 1">
            <ul class="post-pagination">
                <li>
                    <a (click)="loadPage(page - 1)"
                       [class.disabled-link]="page <= 1"
                       style="cursor:pointer">
                        {{ 'sidebar_precedent' | translate }}
                    </a>
                </li>
                <li *ngFor="let p of pages">
                    <a (click)="loadPage(p)"
                       [class.current]="page === p"
                       style="cursor:pointer">{{ p }}</a>
                </li>
                <li>
                    <a (click)="loadPage(page + 1)"
                       [class.disabled-link]="page >= totalPages"
                       style="cursor:pointer">
                        {{ 'sidebar_suivant' | translate }}
                    </a>
                </li>
            </ul>
        </div>

    </div>
</section>
